/**
 * package: com.inq.utils
 * class: Area
 * @extends com.inq.utils.Point 
 * @constructor
 */
com.inq.utils.Area = function(x,y,w,h) {
	com.inq.utils.Point.call(this,x,y);
	this.w = w;
	this.h = h;
};
$hxClasses.extend(com.inq.utils.Point, com.inq.utils.Area, "com.inq.utils.Area");

/**
 * toString
 * Format this object as a string, for debugging purposes.
 *
 * $type TFun([],TInst(String,[]))
 * override public function toString():String
 * @override
 * @public
 * @this com.inq.utils.Area
 * @return {string}
 */
com.inq.utils.Area.prototype.toString = function() {
	return "Area[x: " + this.x + ", y: " + this.y + ", w: " + this.w + ", h: " + this.h + "]";
};


/**
 * equals
 * Determines whether this Area is equivalent to the 
 * given Area.
 *
 * $type TFun([{ name => area, t => TInst(com.inq.utils.Area,[]), opt => false }],TEnum(Bool,[]))
 * public function equals(area:Area):Bool
 * @public
 * @this com.inq.utils.Area
 * @param {com.inq.utils.Area}  area 
 * @return {boolean}
 */
com.inq.utils.Area.prototype.equals = function(area) {
	return this.x == area.x && this.y == area.y && this.w == area.w && this.h == area.h;
};


/**
 * scale
 * Scales the width and height of the current Area by the given
 * factor. NOTE that the zoom factor is NOT the zoom of the
 * current page, but a factor relative to the current size of THIS
 * AREA.  So:
 * 
 * var a = new Area(0, 0, 100, 100); // You create a new 100x100 Area
 * a.scale(0.9); // Scale down by 10%.  Area is now 90x90.
 * a.scale(1.1); // Scale up by 10%.  AREA IS NOW 99x99, NOT 100x100.
 * 
 * This method is intended to be used to scale real pixels (screen
 * size) to css pixels (ex. element.style.width).
 *
 * $type TFun([{ name => zoom, t => TInst(Float,[]), opt => false }],TInst(com.inq.utils.Area,[]))
 * public function scale(zoom:Float):Area
 * @public
 * @this com.inq.utils.Area
 * @param {number}  zoom - Factor by which to scale up/down, relative to current size.  
 * @return {com.inq.utils.Area} - this Area.
 */
com.inq.utils.Area.prototype.scale = function(zoom) {
	this.w = Math.round(this.w * zoom);
	this.h = Math.round(this.h * zoom);
	return this;
};


/**
 * resize - Adjusts the height and width of this Area.
 *
 * $type TFun([{ name => dw, t => TInst(Int,[]), opt => false },{ name => dh, t => TInst(Int,[]), opt => false }],TInst(com.inq.utils.Area,[]))
 * public function resize(dw:Int, dh:Int):Area
 * @public
 * @this com.inq.utils.Area
 * @param {number}  dw - the alteration to be made to the width of this Area 
 * @param {number}  dh - the alteration to be made to the height of this Area 
 * @return {com.inq.utils.Area} - this Area.
 */
com.inq.utils.Area.prototype.resize = function(dw,dh) {
	this.w += dw;
	this.h += dh;
	return this;
};

/**
 * moveInto - Moves this Area into the given Area, snapping to the NW corner
 * if the rest of the area won't fit.
 */
com.inq.utils.Area.prototype.moveInto = function(area) {
	this.x = this.forceRange(this.x, area.x, (area.x + area.w - this.w));
	this.y = this.forceRange(this.y, area.y, (area.y + area.h - this.h));
};


/**
 * copy - Makes a copy of this area.
 *
 * $type TFun([],TInst(com.inq.utils.Area,[]))
 * public function copy():Area
 * @public
 * @this com.inq.utils.Area
 * @return {com.inq.utils.Area} - a copy of this Area.
 */
com.inq.utils.Area.prototype.copy = function() {
	return new com.inq.utils.Area(this.x,this.y,this.w,this.h);
};

/** @type {number} */
com.inq.utils.Area.prototype.h = null;
/** @type {number} */
com.inq.utils.Area.prototype.w = null;
